<template>
    <div class="card h-auto card-filled">
        <div class="card__text h-100 justify-content-center px-4 py-3">
            <div class="data-gender pb-2">
                <span
                    class="pr-4 position-relative data-field"
                    :class="{ active: member.gender == 'M' }"
                    >De Heer</span
                >
                <span
                    class="position-relative data-field"
                    :class="{ active: member.gender == 'F' }"
                    >Mevrouw</span
                >
            </div>
            <div class="data-name d-flex flex-wrap pb-3">
                <span class="font-weight-bold order-sm-1 data-field"
                    >Voornaam</span
                >
                <span class="order-sm-4 data-field">{{
                    member.firstname
                }}</span>
                <span class="font-weight-bold order-sm-2 data-field"
                    >Tussenvoegsel</span
                >
                <span class="order-sm-5 data-field">{{
                    member.middlename ? member.middlename : ''
                }}</span>
                <span class="font-weight-bold order-sm-3 data-field"
                    >Achternaam</span
                >
                <span class="order-sm-6 data-field">{{ member.lastname }}</span>
            </div>
            <div class="data-function pb-2">
                <span class="font-weight-bold order-sm-2 d-block data-field"
                    >Functie</span
                >
                <span class="d-block data-field">{{ member.role }}</span>
            </div>
            <div class="data-company pb-2">
                <span class="font-weight-bold d-block data-field">Bedrijf</span>
                <span class="d-block data-field">{{ member.company }}</span>
            </div>
            <div class="data-address d-flex flex-wrap pb-2">
                <span class="font-weight-bold order-sm-1 data-field"
                    >Adres</span
                >
                <span class="order-sm-3 data-field">{{
                    member.address.street
                }}</span>
                <span class="font-weight-bold order-sm-2 data-field"
                    >Postcode</span
                >
                <span class="order-sm-4 data-field">{{
                    member.address.postalcode
                }}</span>
            </div>
            <div class="data-place d-flex flex-wrap pb-2">
                <span class="font-weight-bold order-sm-1 data-field"
                    >Plaats</span
                >
                <span class="order-sm-3 data-field">{{
                    member.address.city
                }}</span>
                <span class="font-weight-bold order-sm-2 data-field">Land</span>
                <span class="order-sm-4 data-field">{{
                    member.address.country
                }}</span>
            </div>
            <div class="data-contact d-flex flex-wrap pb-3">
                <label class="order-sm-1 data-field" for="phone"
                    ><span class="font-weight-bold">Telefoon</span>
                    <i v-if="error.length" class="data-error d-block">{{
                        error
                    }}</i></label
                >
                <div class="order-sm-3 data-field data-phone position-relative">
                    <input
                        id="phone"
                        v-model="phone"
                        class="w-75"
                        :placeholder="member.phonenumber"
                        type="tel"
                        name="phone"
                        :disabled="isDisabled"
                    />
                    <a v-if="phone.length && !isDisabled" @click="cancelUpdate"
                        ><i class="fas fa-times mr-1"></i
                    ></a>
                    <a v-if="phone.length && !isDisabled" @click="updatePhone"
                        ><i class="fas fa-check"></i
                    ></a>
                </div>
                <label
                    for="phone"
                    class="font-italic order-sm-5 data-field change-phone"
                    @click="isDisabled = !isDisabled"
                    >Telefoonnummer wijzigen</label
                >
                <span class="font-weight-bold order-sm-2 data-field"
                    >E-mail</span
                >
                <span class="order-sm-4 data-field">
                    <a :href="'mailto:' + member.email">{{
                        member.email
                    }}</a></span
                >
            </div>
            <div class="block-text">
                <p>
                    U kunt uw telefoonnummer hier wijzigen. Andere wijzigingen
                    kunt u per <a href="mailto:Ledennet@nvb.nl">mail</a> aan ons
                    doorgeven.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
export default {
    props: {
        member: {
            type: Object,
            default() {
                return {
                    address: {}
                };
            }
        }
    },
    data() {
        return {
            isDisabled: true,
            phone: '',
            error: ''
        };
    },
    methods: {
        updatePhone() {
            Axios.post('/api/v1/domainapi/updatephonenumber', {
                phone: this.phone
            }).then(response => {
                if (response.data.success) {
                    this.isDisabled = true;
                    this.error = '';
                } else {
                    this.error = response.data.errors.fieldName;
                }
            });
        },
        cancelUpdate() {
            this.phone = '';
            this.error = '';
        }
    }
};
</script>

<style lang="scss" scoped>
.data-field {
    @include media-breakpoint-down(sm) {
        width: 100%;
    }
}

.data-gender {
    padding-left: 20px;
}

.data-phone a {
    position: relative;
    left: -45px;
    cursor: pointer;
}

.data-error {
    color: $brand-pink;
}

.data-gender span:after {
    content: '';
    width: 12px;
    height: 12px;
    background-color: $brand-gray;
    position: absolute;
    border-radius: 90px;
    top: 50%;
    transform: translateY(-50%);
    left: -20px;
}

.data-gender span.active:after {
    background-color: $brand-blue;
}

.data-name span {
    @include media-breakpoint-up(sm) {
        width: 33.3%;
    }
}

.data-address span {
    @include media-breakpoint-up(sm) {
        width: 50%;
    }
}

.data-place span {
    @include media-breakpoint-up(sm) {
        width: 50%;
    }
}

.data-contact a {
    font-size: 0.875rem;
}

.data-contact input {
    background-color: $brand-gray;
    border: 0;
    padding: 5px 5px 5px 20px;
    margin-left: -20px;
    margin-bottom: 5px;
}

.data-contact span,
.data-contact label,
.data-contact a,
.data-contact div {
    @include media-breakpoint-up(sm) {
        width: 50%;
    }
}

.change-phone:hover {
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}
</style>
